import React from 'react';

import { IUnpackedFeaturedProduct } from '../../../models/MessagePreview/UnpackedFeaturedProduct';
import OunceFeaturedProduct from './OunceFeaturedProduct';

interface IProps {
  featuredProducts: IUnpackedFeaturedProduct[];
  ranking: boolean;
}

const OunceFeaturedProductList = (props: IProps) => {
  const { featuredProducts, ranking } = props;
  if (featuredProducts) {
    const featuredProductsNodes = featuredProducts.map((featuredProduct, index) => (
      <OunceFeaturedProduct featuredProduct={featuredProduct} rankingIndex={ranking ? index + 1 : undefined } key={index} />
    ));

    return (
      <div className="featured-products">
        {featuredProductsNodes}
      </div>
    );
  }

  return null;
};

export default OunceFeaturedProductList;
